import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import styles from '../MyTransferPage.module.scss';
import { transcationActions } from '../../../stores/_actions';
import popClose from 'assets/images/pop-close.svg';
import popUpStyles from '../../components/popup/PopupModel.module.scss';
import { PopupModel } from '../../components/popup/PopupModel';
function CancelRemittance() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const [reference, setreference] = useState('');
  const [referenceErr, setreferenceErr] = useState({});
  const [remarks, setremarks] = useState('');
  const [remarksErr, setremarksErr] = useState({});
  const dispatch = useDispatch();
  let payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CancelRemarks: remarks,
      CustomerCode: profile?.CustomerCode,
      RefNo: reference,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    Langcode: '0001',
  };

  const [cancelTransData, setData] = useState();
  let [hide, setN] = useState(false);
  const hidePopup = () => {
    setreference('');
    setremarks('');
    setN(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const isValid = formValidation();
    if (!isValid) return;
    dispatch(transcationActions.cancelTransaction(payload));
    setN(true);
  };

  const formValidation = () => {
    const referenceErr = {};
    const remarksErr = {};
    let isValid = true;

    if (reference.trim().length < 1) {
      referenceErr.referenceShort = 'Please enter transaction number';
      isValid = false;
    }
    if (remarks.trim().length < 1) {
      remarksErr.remarksShort = 'Please enter remark';
      isValid = false;
    }
    setreferenceErr(referenceErr);
    setremarksErr(remarksErr);
    return isValid;
  };

  let cancelTrans;
  useSelector(
    (state) => (
      (cancelTrans = state.cancelTransaction?.data),
      setTimeout(() => {
        cancelTrans = state.cancelTransaction?.data;
      }, 100)
    )
  );

  return (
    <div className={styles.pageRight__transfer}>
      <h2>Cancel Remittance</h2>
      <form onSubmit={onSubmit} autoComplete="none">
        <div className={styles.cancelremittance}>
          <input
            type="text"
            placeholder="Transaction Reference Number"
            name="reference"
            value={reference}
            onChange={(e) => {
              setreference(e.target.value);
              setreferenceErr('');
            }}
          />
          {Object.keys(referenceErr).length > 0 ? (
            Object.keys(referenceErr).map((key, index) => {
              return (
                <div key={index} style={{ color: 'red', margin: '0px 0px 11px 0px' }}>
                  {referenceErr[key]}
                </div>
              );
            })
          ) : (
            <br />
          )}
          <textarea
            placeholder="Remarks"
            name="remarks"
            value={remarks}
            onChange={(e) => {
              setremarks(e.target.value);
              setremarksErr('');
            }}
          />
          {Object.keys(remarksErr).length > 0 ? (
            Object.keys(remarksErr).map((key, index) => {
              return (
                <div key={key} style={{ color: 'red', margin: '0px 0px 11px 0px' }}>
                  {remarksErr[key]}
                </div>
              );
            })
          ) : (
            <br />
          )}
          <button type="submit" value="Submit" className={styles.linkButton}>
            {' '}
            Submit
          </button>
        </div>
        {hide && cancelTrans ? (
          <div className={popUpStyles.dialogue}>
            <div className={popUpStyles.dialogue__wrap} style={{ width: '360px' }}>
              <img className={popUpStyles.dialogue__close} src={popClose} onClick={hidePopup} />
              {cancelTrans.statusCode == '200' || cancelTrans.statusCode == '401' ? <p>{cancelTrans.message}</p> : <p>Success</p>}
              {/* <p>It looks like your have not registered with us before. Please click below to register with before proceeding ahead.</p> */}
              <div className={popUpStyles.dialogue__buttons}>
                <Link onClick={hidePopup}>OK</Link>
                {/* <Link onClick={hidePopup} className={styles.LoginPage__link}>
                    Cancel
                    </Link> */}
                {/* <Button onClick={hidePopup} className={styles.LoginPage__link} > Ok</Button> 
                    <Button onClick={hidePopup} className={styles.LoginPage__link} > Cancel</Button>  */}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        {/* {cancelTrans ? <PopupModel data={cancelTrans} /> : ''} */}
        {/* {cancelTrans?.statusCode == '200' ? <div className={styles.formgroup__error}>{cancelTrans.message}</div> : ''} */}
        {/* {cancelTrans?.statusCode == '401' ? <div className={styles.formgroup__error}>{cancelTrans.message}</div> : ''} */}
      </form>
    </div>
  );
}

export { CancelRemittance };
